var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const DefaultCombobox = forwardRef((_a, ref) => {
    var { in: _in } = _a, props = __rest(_a, ["in"]);
    return (_jsx("ul", Object.assign({}, props, { ref: ref, style: {
            cursor: "pointer",
            borderRadius: 4,
            backgroundColor: "rgb(255, 255, 255)",
            boxShadow: "rgb(0 0 0 / 20%) 0px 5px 5px -3px, rgb(0 0 0 / 14%) 0px 8px 10px 1px, rgb(0 0 0 / 12%) 0px 3px 14px 2px",
            listStyle: "none",
            padding: "4px 0",
            margin: 0,
        } })));
});
const DefaultComboboxItem = forwardRef((_a, ref) => {
    var { selected } = _a, props = __rest(_a, ["selected"]);
    return (_jsx("li", Object.assign({}, props, { ref: ref, style: {
            backgroundColor: selected
                ? "rgba(0, 0, 0, 0.04)"
                : "rgb(255, 255, 255)",
            padding: 8,
        } })));
});
export { DefaultCombobox, DefaultComboboxItem };
